import React, { useEffect, useState } from 'react';
import { tipsService } from '../../../../src/services/tipsService';

const TipHistoryPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tab, setTab] = useState<'sent' | 'received'>('sent');
  const [tips, setTips] = useState<any[]>([]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await tipsService.history({ type: tab, limit: 25, offset: 0 });
        setTips(res.tips || []);
      } catch (e: any) {
        setError(e?.response?.data?.error || 'Failed to load tips');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [tab]);

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">My Tips</h1>
          <p className="text-gray-600">View tips you’ve sent and received.</p>
        </div>
        <div className="inline-flex rounded-md shadow-sm" role="group">
          <button onClick={() => setTab('sent')} className={`px-4 py-2 text-sm border ${tab==='sent'?'bg-indigo-600 text-white':'bg-white text-gray-700'}`}>Sent</button>
          <button onClick={() => setTab('received')} className={`px-4 py-2 text-sm border -ml-px ${tab==='received'?'bg-indigo-600 text-white':'bg-white text-gray-700'}`}>Received</button>
        </div>
      </div>

      {loading && <div className="text-gray-600">Loading…</div>}
      {error && <div className="text-red-600">{error}</div>}

      <div className="bg-white rounded-lg shadow p-4">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="py-2">{tab==='sent'?'To':'From'}</th>
              <th className="py-2">Amount</th>
              <th className="py-2">Status</th>
              <th className="py-2">Date</th>
            </tr>
          </thead>
          <tbody>
            {tips.map((tip) => (
              <tr key={tip.id} className="border-t">
                <td className="py-2">{tab==='sent' ? (tip.toCreator?.username || tip.toCreatorId?.slice(0,6)) : (tip.fromUser?.username || tip.fromUserId?.slice(0,6))}</td>
                <td className="py-2">{new Intl.NumberFormat('en-US',{ style:'currency', currency: tip.currency || 'USD'}).format(Number(tip.amount || 0))}</td>
                <td className="py-2">{tip.status}</td>
                <td className="py-2">{new Date(tip.createdAt).toLocaleString()}</td>
              </tr>
            ))}
            {tips.length === 0 && (
              <tr><td colSpan={4} className="py-4 text-gray-500">No tips found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TipHistoryPage;
